import React, { useEffect } from 'react';
import cn from 'classnames';
import { LazyMotion, domAnimation } from 'framer-motion';

import 'sanitize.css';
import '../styles/variables.css';
import '../styles/base.css';
import '../styles/responsive.css';

import * as css from './Layout.module.css';

import { updateFavicon } from '../utils/favicon';

import Head from './Head';

import Footer from './Footer';

const Layout = ({
  children,
  title,
  description,
  type,
  typeMeta,
  meta = [],
  faviconColors,
  image,
  imageMeta,
  canonical,
  withFooter = true,
  className
}) => {
  // Generate a favicon with random colors
  // or with the provided colors of a project
  useEffect(() => {
    updateFavicon(faviconColors);
  }, [faviconColors]);

  return (
    <div className={cn(css.root, className)}>
      <Head
        title={title}
        description={description}
        type={type}
        typeMeta={typeMeta}
        meta={meta}
        image={image}
        imageMeta={imageMeta}
        canonical={canonical}
      />
      <LazyMotion features={domAnimation} strict>
        {children}
        {withFooter && (
          <>
            <Footer />
          </>
        )}
      </LazyMotion>
    </div>
  );
};

export default Layout;
